import { SYSTEM_USER, preloadWebItemLocation } from '@confluence/web-item-location';

export const preloadProfileMenu = () =>
	Promise.all([preloadWebItemLocation({ location: SYSTEM_USER })]);
